import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/lib/constants";
import { Reveal } from "@/components/Reveal";
import { Divider } from "@/components/GoldOrnament";

export default function About({ images = {} }) {
  const { t } = useLang();
  const a = t.about;
  const mainImg = images?.aboutMain || IMAGES.facial;
  const smallImg = images?.aboutSmall || IMAGES.candle;

  return (
    <section id="about" className="bg-ivory py-20 md:py-32 scroll-mt-20" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Text */}
          <div className="lg:col-span-7">
            <Reveal>
              <span className="text-xs tracking-[0.22em] uppercase text-gold font-medium">{a.overline}</span>
              <h2 className="mt-4 font-serif text-3xl md:text-5xl text-ink leading-[1.15] max-w-xl">{a.title}</h2>
              <p className="mt-7 text-base md:text-lg text-taupe leading-relaxed max-w-xl">{a.body}</p>
            </Reveal>

            <div className="mt-12 grid sm:grid-cols-2 gap-x-10 gap-y-8">
              {a.points.map((p, i) => (
                <Reveal key={p.n} delay={i * 0.08}>
                  <div className="flex items-start gap-4 border-t border-sand pt-5" data-testid={`about-point-${i}`}>
                    <span className="font-serif text-xl text-gold shrink-0">{p.n}</span>
                    <span className="text-ink text-base md:text-lg leading-snug">{p.t}</span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          {/* Images */}
          <div className="lg:col-span-5">
            <Reveal delay={0.1}>
              <div className="relative">
                <div className="aspect-[3/4] overflow-hidden rounded-t-[999px] rounded-b-3xl ring-1 ring-gold/25">
                  <img src={mainImg} alt="Soin du visage apaisant" className="h-full w-full object-cover hover:scale-105 transition-transform duration-700" loading="lazy" />
                </div>
                <div className="absolute -bottom-8 end-[-8px] w-2/3 aspect-square overflow-hidden rounded-2xl ring-4 ring-ivory">
                  <img src={smallImg} alt="Ambiance douce et bien-être" className="h-full w-full object-cover hover:scale-105 transition-transform duration-700" loading="lazy" />
                </div>
              </div>
            </Reveal>
          </div>
        </div>
        <Divider className="mt-24" />
      </div>
    </section>
  );
}
